export default (theme) => ({
  root: {
    position: "relative",
    flex: "0 0 auto",
    // The flag overhangs the circle, so nothing here may clip.
    overflow: "visible",
  },
  avatar: {
    width: "100%",
    height: "100%",
    borderRadius: "50%",
    objectFit: "cover",
    display: "block",
  },
  initials: {
    width: "100%",
    height: "100%",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "Futura-Bold",
    // Outline rather than a fill: the match background is a colour or a
    // gradient, so any fill we picked would fight one of them.
    border: "1.5px solid",
    opacity: 0.85,
  },
  flag: {
    position: "absolute",
    right: -5,
    bottom: -6,
    lineHeight: 1,
    filter: "drop-shadow(0 1px 1px rgba(0,0,0,0.25))",
  },
});
